import React from 'react';
import { Linkedin, Twitter, Facebook, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const UTM = 'utm_source=webinar_library&utm_medium=CRM';
const utmUrl = (url) => url + (url.includes('?') ? '&' : '?') + UTM;

const Footer = () => {
  return (
    <footer className="bg-[#1a2ca9] border-t border-[#1a2ca9]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-16">
          {/* Column 1: Trending Programs */}
          <div>
            <h3 className="font-semibold text-white mb-4">Trending Programs</h3>
            <ul className="space-y-2">
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/pg-program-data-science-and-business-analytics-course")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  UT Austin: PG Program in Data Science with Gen AI
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/pg-program-artificial-intelligence-course")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  UT Austin: PG Program in AI and Machine Learning
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/artificial-intelligence-course-for-managers-leaders")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  UT Austin: PG Program in AI for Leaders
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/mit-data-science-program")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  MIT: Applied AI and Data Science Program
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/mit-data-science-and-machine-learning-program")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  MIT IDSS Data Science and ML Course
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2: Browse Courses */}
          <div>
            <h3 className="font-semibold text-white mb-4">Browse Courses</h3>
            <ul className="space-y-2">
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/data-science/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Data Science Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/artificial-intelligence/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Artificial Intelligence Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/gen-ai/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Generative AI
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/software-engineering/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Software Engineering Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/cloud-computing/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Cloud Computing Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/design/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Design Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/cyber-security/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Cyber Security Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/management/courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Management Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/pg-courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Post Graduate (PG) Certificate Courses
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Degrees + Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Degrees</h3>
            <ul className="space-y-2">
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/degrees/mba-courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  MBA Courses
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/degrees/masters-courses")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Masters Courses
                </a>
              </li>
            </ul>

            <h3 className="font-semibold text-white mb-4 mt-6">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/about-us")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/careers")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Careers at Great Learning
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/grievance-redressal")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Grievance Redressal
                </a>
              </li>
              <li>
                <a href={utmUrl("https://www.mygreatlearning.com/contactus")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Logo, Contact, Social */}
          <div className="col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://d1vwxdpzbgdqj.cloudfront.net/s3-public-images/learning-partners/greatlearning-brand-white.svg" 
                alt="Great Learning" 
                className="h-8"
              />
            </Link>
            <div className="space-y-3 mb-6">
              <div>
                <p className="text-xs font-semibold text-white">India:</p>
                <a href="mailto:info@greatlearning.in" className="text-sm text-white/80 hover:text-white transition-colors block">info@greatlearning.in</a>
                <a href="tel:08069474555" className="text-sm text-white/80 hover:text-white transition-colors block">080 6947 4555</a>
              </div>
              <div>
                <p className="text-xs font-semibold text-white">US and Other countries:</p>
                <a href="mailto:info@mygreatlearning.com" className="text-sm text-white/80 hover:text-white transition-colors block">info@mygreatlearning.com</a>
                <a href="tel:+15126472647" className="text-sm text-white/80 hover:text-white transition-colors block">+1 512 647 2647</a>
              </div>
              <div>
                <p className="text-xs font-semibold text-white">For Enterprise queries:</p>
                <a href="mailto:business@greatlearning.in" className="text-sm text-white/80 hover:text-white transition-colors block">business@greatlearning.in</a>
              </div>
            </div>
            <div className="flex space-x-4">
              <a href={utmUrl("https://www.linkedin.com/school/great-learning/")} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href={utmUrl("https://twitter.com/Great_Learning")} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href={utmUrl("https://www.facebook.com/GreatLearningOfficial/")} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href={utmUrl("https://www.youtube.com/user/beaconelearning/")} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/20">
          <div className="flex justify-center items-center gap-2 mb-4">
            <a href={utmUrl("https://www.mygreatlearning.com/privacy-policy")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <span className="text-white/50">•</span>
            <a href={utmUrl("https://www.mygreatlearning.com/terms")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
              Terms of Use
            </a>
            <span className="text-white/50">•</span>
            <a href={utmUrl("https://www.mygreatlearning.com/isms-policy")} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
              ISMS Policy
            </a>
          </div>
          <p className="text-sm text-center text-white/80">
            &copy; 2026 Great Learning. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
